/**
 * Set query on url string
 * @param { string } key - query properity
 * @param { string } value - value of query
 * @param { string } toDelete - query param to delete
 */
export const history = function (key, value, toDelete = null, skupUpdate = false) {
  if (!key || !value) return;

  const url = new URL(window.location);
  if (toDelete) url.searchParams.delete(toDelete);
  url.searchParams.set(key, value);
  url.href = url.href.replace(/%2B/g, '+');
  url.search = url.search.replace(/%2B/g, '+').replace(/%252F/g, '%2F');

  if (!skupUpdate) window.history.pushState({}, '', url);

  return new URL(url);
};

/**
 * Turns string into Shopify like handle
 */
export const handleize = function (str) {
  if (!str) return '';

  return str
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/-$/, '')
    .replace(/^-/, '');
};

/**
 * Replaces special chars in product options
 */
export const sanitizeProductOptions = function (product = null) {
  if (!product) return null;

  // Remove quotes
  let options = [];
  product.options.forEach((option) => {
    options.push(option.replace(/'/g, '').replace(/"/g, ''));
  });

  product.options = options;

  return product;
};
